module.exports = __webpack_public_path__ + "img/gotoschool.48261d49.jpg";